import { render, staticRenderFns } from "./pricing-table-item.vue?vue&type=template&id=d69b3636&scoped=true&"
import script from "./pricing-table-item.vue?vue&type=script&lang=js&"
export * from "./pricing-table-item.vue?vue&type=script&lang=js&"
import style0 from "./pricing-table-item.vue?vue&type=style&index=0&id=d69b3636&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69b3636",
  null
  
)

export default component.exports